import { FilterTag } from "./deriveFilterTag";

export type ParsedFilterTag = {
  bits: number;
  tagBits: bigint; // left-aligned bits, MSB-first
};

/**
 * Parses a 6-byte filter tag back into its bit length and tagBits
 */
export function parseFilterTag({
  tag,
}: {
  tag: Uint8Array,
}): ParsedFilterTag {
  if (tag.length !== 6) throw new Error('Filter tag must be exactly 6 bytes');

  const bits = tag[0];
  if (bits < 1 || bits > 40) {
    throw new Error(`Invalid bits value: ${bits}`);
  }

  let tagBits = 0n;
  for (let i = 1; i < 6; i++) {
    tagBits = (tagBits << 8n) | BigInt(tag[i]);
  }

  return { bits, tagBits };
}